export const isNullOrUndefined = (obj) => obj === null || obj === undefined;
